import classNames from "classnames";
import { LinkItUrl } from "react-linkify-it";

import { Avatar } from "@mwi/ui";

import { MessagesMessage } from "slices/messages";

import DateTimeItem from "../../components/DateTimeItem";

type MessageCardProps = {
  message: MessagesMessage;
  sentByMe?: boolean;
  "data-test-id"?: string;
};

const MessageCard = ({
  message,
  sentByMe,
  "data-test-id": dataTestId,
}: MessageCardProps): JSX.Element => (
  <div
    data-test-id={dataTestId}
    className={classNames("MessageCard mb-6", {
      "tablet:pl-20": sentByMe,
      "tablet:pr-20": !sentByMe,
    })}
  >
    <div
      className={classNames(
        "p-4 pb-6 bg-white shadow-default tablet:shadow-none tablet:border-grey-light tablet:border-l-2",
        { "order-last": sentByMe },
      )}
    >
      <div className="flex flex-col-reverse tablet:flex-row tablet:justify-between tablet:items-center mb-2">
        <div className="flex flex-row gap-3 items-center">
          <Avatar
            data-test-id={`${dataTestId}_Avatar`}
            name={message.sender.displayName}
            className="shrink-0 w-[40px] h-[40px]"
          />
          <p
            className="text-base font-medium overflow-hidden text-ellipsis whitespace-nowrap"
            data-test-id={`${dataTestId}_Name`}
          >
            {sentByMe ? "You" : message.sender.displayName}
          </p>
        </div>
        <DateTimeItem time={message.time} data-test-id={`${dataTestId}_Date`} />
      </div>

      <div className="MessageCard_Body flex flex-row gap-3 items-center">
        <div className="MessageCard_AvatarSpacer shrink-0 w-[40px] h-[1px]"></div>
        <p className="[&>a]:underline" data-test-id={`${dataTestId}_Message`}>
          <LinkItUrl>{message.message}</LinkItUrl>
        </p>
      </div>
    </div>
  </div>
);

export default MessageCard;
